import { render, staticRenderFns } from "./CashbookDesktop.vue?vue&type=template&id=0b77de2c&scoped=true&"
import script from "./CashbookDesktop.vue?vue&type=script&lang=ts&"
export * from "./CashbookDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./CashbookDesktop.vue?vue&type=style&index=0&id=0b77de2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77de2c",
  null
  
)

export default component.exports